<form [formGroup]="form" novalidate>
  <br />
  <wm-de-label [entity]="entity" [for]="entity.templateCode"></wm-de-label>
  <div class="sig-container" #sigContainer1   [class.no-border]="templateForPermitForm"
  >
    <div fxLayout="row" *ngIf="!hasPath">
      <wm-signature-field
        [formControlName]="entity.templateCode"
        (valueChange)="onSignatureValueChange($event)">
      </wm-signature-field>
    </div>
    <div fxLayout="row" *ngIf="hasPath && imagePath">
      <img [src]="imagePath" alt="Signature Image" style="max-width: 100%; height: auto;" />
    </div>
    <div fxLayout="row">
      @if(!templateForPermitForm){
      <button
        type="button"
        class="btn btn-raised btn-sm btn-danger"
        (click)="clear()"
        [disabled]="false"
      >
        Clear
      </button>
      }
      <!-- added by priya 23-12-2025 -->
      @else{
      <wm-common-button
        [data]="{text:'Clear',onClick:clear.bind(this)}"
        class="clear-button"
      >
      </wm-common-button>
      }
      <!-- end by priya 23-12-2025 -->
    </div>
  </div>
  <div *ngIf="entity.includePrintedName" style="margin-top: 8px;">
    <label [for]="entity.templateCode + '_PrintedName'">Printed Name<span *ngIf="entity.isRequired"> *</span></label>
    <input
      type="text"
      class="form-control"
      [id]="entity.templateCode + '_PrintedName'"
      [formControlName]="entity.templateCode + '_PrintedName'"
      [value]="printedName"
      (input)="onPrintedNameChange($event.target.value)"
      placeholder="Enter printed name"
    />
  </div>
</form>
